/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  q: string,
  skip: number,
  limit: limit,
  havingRedirects: boolean
};

type ComposedProps = Props & WithI18nProps;

class ActionsGroupOnListing extends Component<ComposedProps> {
  render() {
    const { i18n, q, skip, limit, havingRedirects } = this.props;
    return (
      <Stack>
        {havingRedirects && (
          <Button
            onClick={() => {
              history.push(`${routes.redirect.edit()}?q=${q}&skip=${skip}&limit=${limit}`);
            }}>
            {i18n.translate('AdminHTML.Common.Action.edit')}
          </Button>
        )}
        {((!havingRedirects && !!q) || havingRedirects) && (
          <Button
            primary
            onClick={() => {
              history.push(routes.redirect.new());
            }}>
            {i18n.translate('AdminHTML.Common.Action.addNew')}
          </Button>
        )}
      </Stack>
    );
  }
}

export default withI18n()(ActionsGroupOnListing);
